
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSettings as ObiChartSettingsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-settings.js';
 
 
 

 
 export const ObiChartSettings = createComponent({
   react: React,
   tagName: 'obi-chart-settings',
   elementClass: ObiChartSettingsElement,
   events: {
     
   }
  });
 
 